/**
 * Armas principais (ficheiros canônicos em Armas/).
 * max = quantidade máxima no simulador.
 */
export const WEAPON_SPECS = [
    { file: "Rifle de Assalto.webp", key: "AK", name: "Rifle de Assalto", priceKey: "AK", max: 3 },
    { file: "Rifle de Ferrolho.webp", key: "BOLT", name: "Rifle de Ferrolho", priceKey: "BOLT", max: 2 },
    { file: "Rifle L96.webp", key: "L96", name: "Rifle L96", priceKey: "L96", max: 3 },
    { file: "M249.webp", key: "M249", name: "M249", priceKey: "M249", max: 3 },
    { file: "LR-300.webp", key: "LR", name: "LR-300", priceKey: "LR", max: 3 },
    { file: "Rifle M39.webp", key: "M39_Rifle", name: "Rifle M39", priceKey: "M39_Rifle", max: 3 },
    { file: "MP5A4.webp", key: "MP5", name: "MP5A4", priceKey: "MP5", max: 2 },
    { file: "Rifle Semiautomático.webp", key: "SEMI", name: "Rifle Semiautomático", priceKey: "SEMI", max: 2 },
    { file: "Thompson.webp", key: "THOMPSON", name: "Thompson", priceKey: "THOMPSON", max: 2 },
    { file: "SMG Personalizada.webp", key: "SUB", name: "SMG Personalizada", priceKey: "SUB", max: 2 },
    { file: "Escopeta SPAS-12.webp", key: "SPAS", name: "Escopeta SPAS-12", priceKey: "SPAS", max: 2 },
    { file: "Escopeta de Repetição.webp", key: "Pump_Shotgun", name: "Escopeta de Repetição", priceKey: "Pump_Shotgun", max: 2 },
    { file: "Escopeta de Cano Duplo.webp", key: "Double_Barrel_Shotgun", name: "Escopeta de Cano Duplo", priceKey: "Pump_Shotgun", max: 2 },
    { file: "Escopeta Cano d'Água.webp", key: "Water_Pipe_Shotgun", name: "Escopeta Cano d'Água", priceKey: "Pump_Shotgun", max: 2 },
    { file: "Rifle de Assalto de Gelo.png", key: "LR", name: "Rifle de Assalto de Gelo", priceKey: "LR", max: 3 },
    { file: "Revólver Python.webp", key: "PYTHON", name: "Revólver Python", priceKey: "PYTHON", max: 2 },
    { file: "Glock.webp", key: "GLOCK", name: "Glock", priceKey: "GLOCK", max: 2 },
    { file: "Pistola M92.webp", key: "M92", name: "Pistola M92", priceKey: "M92", max: 2 },
    { file: "Pistola Semiautomática.webp", key: "P2", name: "Pistola Semiautomática", priceKey: "P2", max: 2 },
    { file: "Lança-Chamas.webp", key: "Flame_Thrower", name: "Lança-Chamas", priceKey: "Flame_Thrower", max: 1 },
    { file: "Lançador de Granadas Múltiplas.webp", key: "Grenade_Launcher", name: "Lançador de Granadas", priceKey: "Grenade_Launcher", max: 1 },
];

/** @deprecated Aliases opcionais — cada ficheiro do manifest é uma entrada no catálogo. */
export const WEAPON_FILE_ALIASES = {};

const BY_FILE = new Map(WEAPON_SPECS.map((s) => [s.file.toLowerCase(), s]));
const BY_KEY = new Map(WEAPON_SPECS.map((s) => [s.key, s]));
const CANONICAL_FILE = new Set(WEAPON_SPECS.map((s) => s.file.toLowerCase()));

function resolveWeaponBasename(filePath) {
    const base = (filePath.split(/[/\\]/).pop() || filePath).toLowerCase();
    return WEAPON_FILE_ALIASES[base] ?? base;
}

/** @param {string} filePath - ex. "itens de armas/Mira 8x.webp" ou "Rifle de Assalto.webp" */
export function getWeaponSpec(filePath) {
    if (!filePath) return null;
    const resolved = resolveWeaponBasename(filePath);
    return BY_FILE.get(resolved) ?? null;
}

/** Primeira entrada canônica por weaponKey (ícone estável no pool). */
export function getCanonicalWeaponSpec(weaponKey) {
    return BY_KEY.get(weaponKey) ?? null;
}

export function isCanonicalWeaponFile(filePath) {
    const base = (filePath.split(/[/\\]/).pop() || filePath).toLowerCase();
    return CANONICAL_FILE.has(base);
}

/** Em Armas inclui armas, acessórios, granadas, melee, etc. */
export function isWeaponCatalogFile(categoryFolder) {
    return true;
}

export function getWeaponKeyFromCatalogEntry(entry) {
    if (!entry?.iconFile) return entry?.weaponKey ?? null;
    const spec = getWeaponSpec(entry.iconFile);
    return spec?.key ?? entry.weaponKey ?? null;
}
